import column from './BaseColumn.vue'
const BaseColumn = {
  install: function (Vue) {
    Vue.component('BaseColumn', column)
  }
}
export default BaseColumn
